import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'tamagui';

interface SeperatorProps {
  width?: number;
  orientation?: 'horizontal' | 'vertical';
  borderColor?: string;
  dividerStyle?: StyleProp<ViewStyle>;
}



export const Separator: React.FC<SeperatorProps> = ({
  width = 4,
  orientation = 'horizontal',
  borderColor = '#23587A14',
  dividerStyle,
}) => {
  const theme = useTheme()
  const dividerStyles: StyleProp<ViewStyle> = [
    { width: orientation === 'horizontal' ? '100%' : width },
    { height: orientation === 'vertical' ? '100%' : width },
    { minHeight: orientation === 'vertical' ? '100%' : width },
    { backgroundColor: theme['separatorColor']?.val },
    dividerStyle,
  ];

  return <View style={dividerStyles} />;
};
